namespace Nobox.Administration {

    @Serenity.Decorators.registerFormatter()
    export class TenantLevelFormatter implements Slick.Formatter {
        format(ctx: Slick.FormatterContext) {
            var item = ctx.value;
            if (item == 1) {
                return `Trial`;
            } else if (item == 2) {
                return `Basic`;
            } else if (item == 3) {
                return `Pro`;
            } else if (item == 4) {
                return `Unlimited`;
            }
        }
    }
}